export default "__VITE_ASSET__09418461__"